<template>
  <div id="foot" class="foot" @click="toPay">
    <img src="../../assets/img/kaitongyongjiuvip@2x.png" alt="">
    <div>立即开通</div>
  </div>
</template>
<script>
export default {
  name: "footH5",
  methods: {
    goLogin: function() {
      this.$router.replace("/login");
    }
  },
  methods:{
    toPay:function(){
      this.$router.push("/pay2");
    }
  }
};
</script>
<style scoped>
.foot {
  position: absolute;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  height: 136px;
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(238, 176, 142, 1) 0%,
    rgba(249, 220, 193, 1) 100%
  );
}
.foot {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 998;
  text-align: center;
}

.foot div {
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 136px;
}
.foot img{
  width: 178px;
  height: 48px;
  position:absolute;
  left: 430px;
  top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/common/vipBotton2.vue